// eslint-disable-next-line max-len
import { DEFINITIONS as LIST_ITEM_PLUGIN_DEFINITIONS } from '@xingternal/content-editor-plugin-list-item';
// eslint-disable-next-line max-len
import { DEFINITIONS as ORDERED_LIST_PLUGIN_DEFINITIONS } from '@xingternal/content-editor-plugin-ordered-list';
// eslint-disable-next-line max-len
import { DEFINITIONS as UNORDERED_LIST_PLUGIN_DEFINITIONS } from '@xingternal/content-editor-plugin-unordered-list';

import {
  DESERIALIZATION,
  SERIALIZATION,
  INPUT_DEFINITIONS_FOR_ORDERED_LIST_ITEMS,
  INPUT_DEFINITIONS_FOR_UNORDERED_LIST_ITEMS,
  OUTPUT_DEFINITIONS_FOR_ORDERED_LIST_ITEMS,
  OUTPUT_DEFINITIONS_FOR_UNORDERED_LIST_ITEMS,
} from '../constants';

const listItemSerializer = ({
  createBlock,
  direction,
  extractChildren,
  matchBlock,
  node,
  normalizeInlinesChildren,
  serializeNodes,
}) => {
  if (
    direction === SERIALIZATION &&
    matchBlock({ node, match: LIST_ITEM_PLUGIN_DEFINITIONS })
  ) {
    let children = extractChildren({ node });
    children = normalizeInlinesChildren({ children });
    let childrenNodes = serializeNodes(children);
    let listItemDefinitions;

    switch (node.listType) {
      case ORDERED_LIST_PLUGIN_DEFINITIONS.type:
        listItemDefinitions = INPUT_DEFINITIONS_FOR_ORDERED_LIST_ITEMS;
        break;
      case UNORDERED_LIST_PLUGIN_DEFINITIONS.type:
        listItemDefinitions = INPUT_DEFINITIONS_FOR_UNORDERED_LIST_ITEMS;
        break;
    }

    return createBlock({
      node,
      definitions: listItemDefinitions,
      children: childrenNodes,
    });
  }

  if (
    direction === DESERIALIZATION &&
    (matchBlock({ node, match: OUTPUT_DEFINITIONS_FOR_ORDERED_LIST_ITEMS }) ||
      matchBlock({ node, match: OUTPUT_DEFINITIONS_FOR_UNORDERED_LIST_ITEMS }))
  ) {
    let children = extractChildren({ node });
    children = serializeNodes(children);
    let childrenNodes = normalizeInlinesChildren({ children });
    let list = {
      children: [],
    };
    let listItem;

    if (
      matchBlock({ node, match: OUTPUT_DEFINITIONS_FOR_ORDERED_LIST_ITEMS })
    ) {
      list.type = ORDERED_LIST_PLUGIN_DEFINITIONS.type;
      listItem = createBlock({
        node,
        definitions: OUTPUT_DEFINITIONS_FOR_ORDERED_LIST_ITEMS,
        children: childrenNodes[0],
      });
    }
    if (
      matchBlock({ node, match: OUTPUT_DEFINITIONS_FOR_UNORDERED_LIST_ITEMS })
    ) {
      list.type = UNORDERED_LIST_PLUGIN_DEFINITIONS.type;
      listItem = createBlock({
        node,
        definitions: OUTPUT_DEFINITIONS_FOR_UNORDERED_LIST_ITEMS,
        children: childrenNodes[0],
      });
    }
    // no need to check for its existance, if it's being deserialized, it is known to exist.
    list.children.push(listItem);
    return list;
  }
};

export { listItemSerializer };
